import { useEffect, useState } from 'react'
import {
  EmailShareButton,
  FacebookShareButton,
  TwitterShareButton as XShareButton,
  WhatsappShareButton,
} from 'react-share'
import { IPageSEO } from '../../types'
import {
  Container,
  EmailDarkThemeFlIcon,
  EmailFlIcon,
  EmailIcon,
  FacebookDarkThemeFlIcon,
  FacebookFlIcon,
  FacebookIcon,
  TwitterIcon,
  WhatsappDarkThemeFlIcon,
  WhatsappFlIcon,
  WhatsappIcon,
  XDarkThemeFlIcon,
  XFlIcon,
} from './ShareButtons.styles'
import { useFL } from '../../hooks/useFL'

type Props = {
  SEO: IPageSEO
  title?: string
  size?: string
  anchor?: string
  isFaceLift?: boolean
  containerRef?: React.Ref<HTMLDivElement>
  icons?: {
    facebook: boolean
    x: boolean
    whatsapp: boolean
    email: boolean
    native: boolean
  }
}

type IStateData = {
  url: string
  postTitle: string
}
const defaultIcons = {
  facebook: true,
  x: true,
  whatsapp: true,
  email: false,
  native: false,
}
export const ShareButtons = ({
  SEO,
  title,
  size,
  anchor,
  containerRef,
  isFaceLift,
  icons = defaultIcons,
}: Props) => {
  const [data, setData] = useState<IStateData>()
  const { isDarkTheme } = useFL()
  useEffect(() => {
    let url = document.URL
    url = url.split('#')[0]

    if (anchor) {
      url += anchor
    }
    setData({
      url: url,
      postTitle: title || SEO.og.title,
    })
  }, [anchor, title, SEO.og.title])

  if (!data) {
    return null
  }
  const { postTitle, url } = data
  return (
    <Container ref={containerRef}>
      {icons.facebook && (
        <FacebookShareButton url={url} title={postTitle}>
          {isFaceLift ? (
            isDarkTheme ? (
              <FacebookDarkThemeFlIcon size={size} />
            ) : (
              <FacebookFlIcon size={size} />
            )
          ) : (
            <FacebookIcon size={size} />
          )}
        </FacebookShareButton>
      )}
      {icons.x && (
        <XShareButton url={url} title={postTitle}>
          {isFaceLift ? (
            isDarkTheme ? (
              <XDarkThemeFlIcon size={size} />
            ) : (
              <XFlIcon size={size} />
            )
          ) : (
            <TwitterIcon size={size} />
          )}
        </XShareButton>
      )}
      {icons.whatsapp && (
        <WhatsappShareButton url={url} title={postTitle}>
          {isFaceLift ? (
            isDarkTheme ? (
              <WhatsappDarkThemeFlIcon size={size} />
            ) : (
              <WhatsappFlIcon size={size} />
            )
          ) : (
            <WhatsappIcon size={size} />
          )}
        </WhatsappShareButton>
      )}
      {icons.email && (
        <EmailShareButton url={url} body={postTitle}>
          {isFaceLift ? (
            isDarkTheme ? (
              <EmailDarkThemeFlIcon size={size} />
            ) : (
              <EmailFlIcon size={size} />
            )
          ) : (
            <EmailIcon size={size} />
          )}
        </EmailShareButton>
      )}
    </Container>
  )
}
